import {
  getAccountValueFromAccountName,
  getAccountValueFromAccountId
} from '../constants/returnPreviewAccountOptions'

export const setInitialValues = (data: any, returnItems?: { id?: number; accountId: number; justification: string }[]) => {
  const parsedData = {
    economicGroup: data.economicGroup || '',
    profitCenter: data.profitCenter || '',
    budget: data.budget || '',
    actualPreview: data.actualPreview || '',
    deviationVsBudget: data.deviationVsBudget || '',
    accounts:
      returnItems && returnItems.length > 0
        ? returnItems.map((item) => ({
            account: getAccountValueFromAccountId(item.accountId),
            returnJustification: item.justification || '',
            draftItemId: item.id != null ? String(item.id) : ''
          }))
        : [
            {
              account: data.account != null ? getAccountValueFromAccountName(String(data.account)) : '',
              returnJustification: '',
              draftItemId: ''
            }
          ]
  }

  return parsedData
}
